/* tslint:disable */
/* eslint-disable */
/**
 * Radianse Progression API - .Net 6
 * <b>Build:</b>Radianse.App.Progression_main_2023.8.16.1
 *
 * The version of the OpenAPI document: UserApi_V1
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 *
 * @export
 * @interface IProgressionConfiguration
 */
export interface IProgressionConfiguration {
  /**
   * PartitionKey
   * @type {string}
   * @memberof IProgressionConfiguration
   */
  partitionKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfiguration
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfiguration
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfiguration
   */
  subCategory?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfiguration
   */
  elementTreeId: string;
  /**
   *
   * @type {Array<IProgressionLevel>}
   * @memberof IProgressionConfiguration
   */
  levels?: Array<IProgressionLevel>;
  /**
   *
   * @type {Array<string>}
   * @memberof IProgressionConfiguration
   */
  maintenancePatterns?: Array<string>;
}
/**
 * Progression data.
 * @export
 * @interface IProgressionConfigurationDto
 */
export interface IProgressionConfigurationDto {
  /**
   * A list of progression levels.
   * @type {Array<IProgressionLevel>}
   * @memberof IProgressionConfigurationDto
   */
  levels: Array<IProgressionLevel>;
  /**
   *
   * @type {Array<string>}
   * @memberof IProgressionConfigurationDto
   */
  maintenancePatterns: Array<string>;
}
/**
 *
 * @export
 * @interface IProgressionConfigurationIRadianseResult
 */
export interface IProgressionConfigurationIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IProgressionConfiguration}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  data?: IProgressionConfiguration;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionConfigurationIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Class to show the list of elementTreeIds progression should track
 * @export
 * @interface IProgressionElementTreeIds
 */
export interface IProgressionElementTreeIds {
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIds
   */
  partitionKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIds
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIds
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIds
   */
  subCategory?: string;
  /**
   * ElementTreeIds
   * @type {Array<string>}
   * @memberof IProgressionElementTreeIds
   */
  elementTreeIds?: Array<string>;
}
/**
 * Class to show the list of elementTreeIds progression should track
 * @export
 * @interface IProgressionElementTreeIdsDto
 */
export interface IProgressionElementTreeIdsDto {
  /**
   * ElementTreeIds
   * @type {Array<string>}
   * @memberof IProgressionElementTreeIdsDto
   */
  elementTreeIds?: Array<string>;
}
/**
 *
 * @export
 * @interface IProgressionElementTreeIdsIRadianseResult
 */
export interface IProgressionElementTreeIdsIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IProgressionElementTreeIds}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  data?: IProgressionElementTreeIds;
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionElementTreeIdsIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IProgressionLevel
 */
export interface IProgressionLevel {
  /**
   *
   * @type {number}
   * @memberof IProgressionLevel
   */
  level?: number;
  /**
   *
   * @type {string}
   * @memberof IProgressionLevel
   */
  pattern?: string;
  /**
   *
   * @type {number}
   * @memberof IProgressionLevel
   */
  startingIndex?: number;
}
/**
 *
 * @export
 * @interface IProgressionPerson
 */
export interface IProgressionPerson {
  /**
   * The id of the object. PersonId
   * @type {string}
   * @memberof IProgressionPerson
   */
  id?: string;
  /**
   * Constant
   * @type {string}
   * @memberof IProgressionPerson
   */
  partitionKey?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionPerson
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionPerson
   */
  subCategory?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionPerson
   */
  personId?: string;
  /**
   * Key is elementTreeId
   * @type {{ [key: string]: IProgressionPersonData; }}
   * @memberof IProgressionPerson
   */
  progression?: { [key: string]: IProgressionPersonData };
}
/**
 * The progression value the person has progressed too
 * @export
 * @interface IProgressionPersonData
 */
export interface IProgressionPersonData {
  /**
   * The current value
   * @type {number}
   * @memberof IProgressionPersonData
   */
  value: number;
  /**
   * The pending value
   * @type {number}
   * @memberof IProgressionPersonData
   */
  pendingValue: number;
}
/**
 *
 * @export
 * @interface IProgressionPersonIRadianseResult
 */
export interface IProgressionPersonIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IProgressionPersonIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IProgressionPerson}
   * @memberof IProgressionPersonIRadianseResult
   */
  data?: IProgressionPerson;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IProgressionPersonIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IProgressionPersonIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IProgressionPersonIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IProgressionPersonIRadianseResultSuccess
 */
export interface IProgressionPersonIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IProgressionPerson}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  data: IProgressionPerson;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionPersonIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IProgressionSessions
 */
export interface IProgressionSessions {
  /**
   * The id of the object. PersonId
   * @type {string}
   * @memberof IProgressionSessions
   */
  id?: string | null;
  /**
   * Constant
   * @type {string}
   * @memberof IProgressionSessions
   */
  partitionKey?: string | null;
  /**
   * The Category. This is always History.
   * @type {string}
   * @memberof IProgressionSessions
   */
  category?: string;
  /**
   * The SubCategory is the class name.
   * @type {string}
   * @memberof IProgressionSessions
   */
  subCategory?: string;
  /**
   * The person associated with this data.
   * @type {string}
   * @memberof IProgressionSessions
   */
  personId?: string;
  /**
   * The person\'s partitionKey
   * @type {string}
   * @memberof IProgressionSessions
   */
  personPartitionKey?: string;
  /**
   * The element tree that identifies the type of device being used.
   * @type {string}
   * @memberof IProgressionSessions
   */
  elementTreeId?: string;
  /**
   * The start of the period the data manages.
   * @type {string}
   * @memberof IProgressionSessions
   */
  periodStartDate?: string;
  /**
   * The pending start date
   * @type {string}
   * @memberof IProgressionSessions
   */
  pendingPeriodStartDate?: string | null;
  /**
   * The list of the 31 last usage dates.
   * @type {Array<string>}
   * @memberof IProgressionSessions
   */
  sessions?: Array<string>;
}
/**
 *
 * @export
 * @interface IProgressionSessionsIRadianseResult
 */
export interface IProgressionSessionsIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IProgressionSessionsIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IProgressionSessions}
   * @memberof IProgressionSessionsIRadianseResult
   */
  data?: IProgressionSessions;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IProgressionSessionsIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IProgressionSessionsIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IProgressionSessionsIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IProgressionSessionsIRadianseResultSuccess
 */
export interface IProgressionSessionsIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IProgressionSessions}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  data: IProgressionSessions;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionSessionsIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * Progression Time Request class
 * @export
 * @interface IProgressionTimeReq
 */
export interface IProgressionTimeReq {
  /**
   * Element tree id
   * @type {string}
   * @memberof IProgressionTimeReq
   */
  elementTreeId?: string;
  /**
   * Resources to get progression time
   * @type {Array<IScheduleResourceInfo>}
   * @memberof IProgressionTimeReq
   */
  resources: Array<IScheduleResourceInfo>;
}
/**
 * Response to get the time a person can use equipment
 * @export
 * @interface IProgressionTimeResp
 */
export interface IProgressionTimeResp {
  /**
   * The time in minutes the manufacturer indicates to tan
   * @type {number}
   * @memberof IProgressionTimeResp
   */
  minutes: number;
  /**
   * Skin type
   * @type {string}
   * @memberof IProgressionTimeResp
   */
  skinType: string;
  /**
   * The progression times that apply to the model
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IProgressionTimeResp
   */
  modelProgression: { [key: string]: Array<string> };
}
/**
 *
 * @export
 * @interface IProgressionTimeRespIRadianseResult
 */
export interface IProgressionTimeRespIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IProgressionTimeResp}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  data?: IProgressionTimeResp;
  /**
   *
   * @type {string}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProgressionTimeRespIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IScheduleResourceInfo
 */
export interface IScheduleResourceInfo {
  /**
   *
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  partitionKey: string;
  /**
   *
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  category: string;
  /**
   *
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  subCategory: string;
  /**
   *
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  name: string;
}

/**
 * ElementTreeIdsConfigApi - axios parameter creator
 * @export
 */
export const ElementTreeIdsConfigApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: elementtreeids_delete
     * @summary Delete the list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeIdsConfigDelete: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ElementTreeIdsConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtreeids_read                Tanning guid will return a default configuration if not found.
     * @summary Get list of elementTreeIds which progression is performed on
     * @param {boolean} [forceReread]
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeIdsConfigGet: async (
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ElementTreeIdsConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (forceReread !== undefined) {
        localVarQueryParameter["forceReread"] = forceReread;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtreeids_create
     * @summary Create or edit list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IProgressionElementTreeIdsDto} [iProgressionElementTreeIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeIdsConfigPut: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iProgressionElementTreeIdsDto?: IProgressionElementTreeIdsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ElementTreeIdsConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iProgressionElementTreeIdsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtreeids_delete
     * @summary Delete the list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ElementTreeIdsConfigDelete: async (
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/ElementTreeIdsConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtreeids_read                Tanning guid will return a default configuration if not found.
     * @summary Get list of elementTreeIds which progression is performed on
     * @param {boolean} [forceReread]
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ElementTreeIdsConfigGet: async (
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/ElementTreeIdsConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (forceReread !== undefined) {
        localVarQueryParameter["forceReread"] = forceReread;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: elementtreeids_create
     * @summary Create or edit list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {IProgressionElementTreeIdsDto} [iProgressionElementTreeIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ElementTreeIdsConfigPut: async (
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iProgressionElementTreeIdsDto?: IProgressionElementTreeIdsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/ElementTreeIdsConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iProgressionElementTreeIdsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ElementTreeIdsConfigApi - functional programming interface
 * @export
 */
export const ElementTreeIdsConfigApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    ElementTreeIdsConfigApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: elementtreeids_delete
     * @summary Delete the list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementTreeIdsConfigDelete(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionElementTreeIdsIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementTreeIdsConfigDelete(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtreeids_read                Tanning guid will return a default configuration if not found.
     * @summary Get list of elementTreeIds which progression is performed on
     * @param {boolean} [forceReread]
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementTreeIdsConfigGet(
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionElementTreeIdsIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementTreeIdsConfigGet(
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtreeids_create
     * @summary Create or edit list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IProgressionElementTreeIdsDto} [iProgressionElementTreeIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiElementTreeIdsConfigPut(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iProgressionElementTreeIdsDto?: IProgressionElementTreeIdsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionElementTreeIdsIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiElementTreeIdsConfigPut(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iProgressionElementTreeIdsDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtreeids_delete
     * @summary Delete the list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ElementTreeIdsConfigDelete(
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionElementTreeIdsIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ElementTreeIdsConfigDelete(
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtreeids_read                Tanning guid will return a default configuration if not found.
     * @summary Get list of elementTreeIds which progression is performed on
     * @param {boolean} [forceReread]
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ElementTreeIdsConfigGet(
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionElementTreeIdsIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ElementTreeIdsConfigGet(
          forceReread,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: elementtreeids_create
     * @summary Create or edit list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {IProgressionElementTreeIdsDto} [iProgressionElementTreeIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ElementTreeIdsConfigPut(
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iProgressionElementTreeIdsDto?: IProgressionElementTreeIdsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionElementTreeIdsIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ElementTreeIdsConfigPut(
          groupId,
          tenantId,
          acceptLanguage,
          iProgressionElementTreeIdsDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ElementTreeIdsConfigApi - factory interface
 * @export
 */
export const ElementTreeIdsConfigApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ElementTreeIdsConfigApiFp(configuration);
  return {
    /**
     * Permission: elementtreeids_delete
     * @summary Delete the list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeIdsConfigDelete(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionElementTreeIdsIRadianseResult> {
      return localVarFp
        .userApiElementTreeIdsConfigDelete(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtreeids_read                Tanning guid will return a default configuration if not found.
     * @summary Get list of elementTreeIds which progression is performed on
     * @param {boolean} [forceReread]
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeIdsConfigGet(
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionElementTreeIdsIRadianseResult> {
      return localVarFp
        .userApiElementTreeIdsConfigGet(
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtreeids_create
     * @summary Create or edit list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IProgressionElementTreeIdsDto} [iProgressionElementTreeIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiElementTreeIdsConfigPut(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iProgressionElementTreeIdsDto?: IProgressionElementTreeIdsDto,
      options?: any
    ): AxiosPromise<IProgressionElementTreeIdsIRadianseResult> {
      return localVarFp
        .userApiElementTreeIdsConfigPut(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iProgressionElementTreeIdsDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtreeids_delete
     * @summary Delete the list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ElementTreeIdsConfigDelete(
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionElementTreeIdsIRadianseResult> {
      return localVarFp
        .userApiV1ElementTreeIdsConfigDelete(
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtreeids_read                Tanning guid will return a default configuration if not found.
     * @summary Get list of elementTreeIds which progression is performed on
     * @param {boolean} [forceReread]
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ElementTreeIdsConfigGet(
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionElementTreeIdsIRadianseResult> {
      return localVarFp
        .userApiV1ElementTreeIdsConfigGet(
          forceReread,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: elementtreeids_create
     * @summary Create or edit list of elementTreeIds which progression is performed on
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {IProgressionElementTreeIdsDto} [iProgressionElementTreeIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ElementTreeIdsConfigPut(
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iProgressionElementTreeIdsDto?: IProgressionElementTreeIdsDto,
      options?: any
    ): AxiosPromise<IProgressionElementTreeIdsIRadianseResult> {
      return localVarFp
        .userApiV1ElementTreeIdsConfigPut(
          groupId,
          tenantId,
          acceptLanguage,
          iProgressionElementTreeIdsDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ElementTreeIdsConfigApi - object-oriented interface
 * @export
 * @class ElementTreeIdsConfigApi
 * @extends {BaseAPI}
 */
export class ElementTreeIdsConfigApi extends BaseAPI {
  /**
   * Permission: elementtreeids_delete
   * @summary Delete the list of elementTreeIds which progression is performed on
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeIdsConfigApi
   */
  public userApiElementTreeIdsConfigDelete(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeIdsConfigApiFp(this.configuration)
      .userApiElementTreeIdsConfigDelete(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtreeids_read                Tanning guid will return a default configuration if not found.
   * @summary Get list of elementTreeIds which progression is performed on
   * @param {boolean} [forceReread]
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeIdsConfigApi
   */
  public userApiElementTreeIdsConfigGet(
    forceReread?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeIdsConfigApiFp(this.configuration)
      .userApiElementTreeIdsConfigGet(
        forceReread,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtreeids_create
   * @summary Create or edit list of elementTreeIds which progression is performed on
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IProgressionElementTreeIdsDto} [iProgressionElementTreeIdsDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeIdsConfigApi
   */
  public userApiElementTreeIdsConfigPut(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iProgressionElementTreeIdsDto?: IProgressionElementTreeIdsDto,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeIdsConfigApiFp(this.configuration)
      .userApiElementTreeIdsConfigPut(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iProgressionElementTreeIdsDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtreeids_delete
   * @summary Delete the list of elementTreeIds which progression is performed on
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeIdsConfigApi
   */
  public userApiV1ElementTreeIdsConfigDelete(
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeIdsConfigApiFp(this.configuration)
      .userApiV1ElementTreeIdsConfigDelete(
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtreeids_read                Tanning guid will return a default configuration if not found.
   * @summary Get list of elementTreeIds which progression is performed on
   * @param {boolean} [forceReread]
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeIdsConfigApi
   */
  public userApiV1ElementTreeIdsConfigGet(
    forceReread?: boolean,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeIdsConfigApiFp(this.configuration)
      .userApiV1ElementTreeIdsConfigGet(
        forceReread,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: elementtreeids_create
   * @summary Create or edit list of elementTreeIds which progression is performed on
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [acceptLanguage]
   * @param {IProgressionElementTreeIdsDto} [iProgressionElementTreeIdsDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ElementTreeIdsConfigApi
   */
  public userApiV1ElementTreeIdsConfigPut(
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    iProgressionElementTreeIdsDto?: IProgressionElementTreeIdsDto,
    options?: AxiosRequestConfig
  ) {
    return ElementTreeIdsConfigApiFp(this.configuration)
      .userApiV1ElementTreeIdsConfigPut(
        groupId,
        tenantId,
        acceptLanguage,
        iProgressionElementTreeIdsDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ProgressionConfigurationApi - axios parameter creator
 * @export
 */
export const ProgressionConfigurationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: progressionconfiguration_read                Tanning guid fbd65957-9a8a-48ed-bd06-d09d2d99a490 will return a default configuration if not found.
     * @summary Get progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {boolean} [forceReread] If null or false, read from cache. If true, read from database.
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiProgressionConfigurationProgressionConfigurationElementTreeIdGet:
      async (
        elementTreeId: string,
        forceReread?: boolean,
        groupId?: string,
        tenantId?: string,
        apiVersion?: string,
        acceptLanguage?: string,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'elementTreeId' is not null or undefined
        assertParamExists(
          "userApiProgressionConfigurationProgressionConfigurationElementTreeIdGet",
          "elementTreeId",
          elementTreeId
        );
        const localVarPath =
          `/UserApi/ProgressionConfiguration/ProgressionConfiguration/{elementTreeId}`.replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "Authorization",
          configuration
        );

        if (forceReread !== undefined) {
          localVarQueryParameter["forceReread"] = forceReread;
        }

        if (groupId !== undefined) {
          localVarQueryParameter["groupId"] = groupId;
        }

        if (tenantId !== undefined) {
          localVarQueryParameter["tenantId"] = tenantId;
        }

        if (apiVersion !== undefined) {
          localVarQueryParameter["api-version"] = apiVersion;
        }

        if (acceptLanguage != null) {
          localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     * Permission: progressionconfiguration_create
     * @summary Creates progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IProgressionConfigurationDto} [iProgressionConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiProgressionConfigurationProgressionConfigurationElementTreeIdPut:
      async (
        elementTreeId: string,
        groupId?: string,
        tenantId?: string,
        apiVersion?: string,
        acceptLanguage?: string,
        iProgressionConfigurationDto?: IProgressionConfigurationDto,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'elementTreeId' is not null or undefined
        assertParamExists(
          "userApiProgressionConfigurationProgressionConfigurationElementTreeIdPut",
          "elementTreeId",
          elementTreeId
        );
        const localVarPath =
          `/UserApi/ProgressionConfiguration/ProgressionConfiguration/{elementTreeId}`.replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "PUT",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "Authorization",
          configuration
        );

        if (groupId !== undefined) {
          localVarQueryParameter["groupId"] = groupId;
        }

        if (tenantId !== undefined) {
          localVarQueryParameter["tenantId"] = tenantId;
        }

        if (apiVersion !== undefined) {
          localVarQueryParameter["api-version"] = apiVersion;
        }

        if (acceptLanguage != null) {
          localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
        }

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          iProgressionConfigurationDto,
          localVarRequestOptions,
          configuration
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     * Permission: progressionconfiguration_read                Tanning guid fbd65957-9a8a-48ed-bd06-d09d2d99a490 will return a default configuration if not found.
     * @summary Get progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {boolean} [forceReread] If null or false, read from cache. If true, read from database.
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdGet:
      async (
        elementTreeId: string,
        forceReread?: boolean,
        groupId?: string,
        tenantId?: string,
        acceptLanguage?: string,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'elementTreeId' is not null or undefined
        assertParamExists(
          "userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdGet",
          "elementTreeId",
          elementTreeId
        );
        const localVarPath =
          `/UserApi/v1/ProgressionConfiguration/ProgressionConfiguration/{elementTreeId}`.replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "Authorization",
          configuration
        );

        if (forceReread !== undefined) {
          localVarQueryParameter["forceReread"] = forceReread;
        }

        if (groupId !== undefined) {
          localVarQueryParameter["groupId"] = groupId;
        }

        if (tenantId !== undefined) {
          localVarQueryParameter["tenantId"] = tenantId;
        }

        if (acceptLanguage != null) {
          localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     * Permission: progressionconfiguration_create
     * @summary Creates progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {IProgressionConfigurationDto} [iProgressionConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdPut:
      async (
        elementTreeId: string,
        groupId?: string,
        tenantId?: string,
        acceptLanguage?: string,
        iProgressionConfigurationDto?: IProgressionConfigurationDto,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'elementTreeId' is not null or undefined
        assertParamExists(
          "userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdPut",
          "elementTreeId",
          elementTreeId
        );
        const localVarPath =
          `/UserApi/v1/ProgressionConfiguration/ProgressionConfiguration/{elementTreeId}`.replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "PUT",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "Authorization",
          configuration
        );

        if (groupId !== undefined) {
          localVarQueryParameter["groupId"] = groupId;
        }

        if (tenantId !== undefined) {
          localVarQueryParameter["tenantId"] = tenantId;
        }

        if (acceptLanguage != null) {
          localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
        }

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          iProgressionConfigurationDto,
          localVarRequestOptions,
          configuration
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
  };
};

/**
 * ProgressionConfigurationApi - functional programming interface
 * @export
 */
export const ProgressionConfigurationApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    ProgressionConfigurationApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: progressionconfiguration_read                Tanning guid fbd65957-9a8a-48ed-bd06-d09d2d99a490 will return a default configuration if not found.
     * @summary Get progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {boolean} [forceReread] If null or false, read from cache. If true, read from database.
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiProgressionConfigurationProgressionConfigurationElementTreeIdGet(
      elementTreeId: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiProgressionConfigurationProgressionConfigurationElementTreeIdGet(
          elementTreeId,
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: progressionconfiguration_create
     * @summary Creates progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IProgressionConfigurationDto} [iProgressionConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiProgressionConfigurationProgressionConfigurationElementTreeIdPut(
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iProgressionConfigurationDto?: IProgressionConfigurationDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiProgressionConfigurationProgressionConfigurationElementTreeIdPut(
          elementTreeId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iProgressionConfigurationDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: progressionconfiguration_read                Tanning guid fbd65957-9a8a-48ed-bd06-d09d2d99a490 will return a default configuration if not found.
     * @summary Get progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {boolean} [forceReread] If null or false, read from cache. If true, read from database.
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdGet(
      elementTreeId: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdGet(
          elementTreeId,
          forceReread,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: progressionconfiguration_create
     * @summary Creates progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {IProgressionConfigurationDto} [iProgressionConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdPut(
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iProgressionConfigurationDto?: IProgressionConfigurationDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdPut(
          elementTreeId,
          groupId,
          tenantId,
          acceptLanguage,
          iProgressionConfigurationDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ProgressionConfigurationApi - factory interface
 * @export
 */
export const ProgressionConfigurationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProgressionConfigurationApiFp(configuration);
  return {
    /**
     * Permission: progressionconfiguration_read                Tanning guid fbd65957-9a8a-48ed-bd06-d09d2d99a490 will return a default configuration if not found.
     * @summary Get progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {boolean} [forceReread] If null or false, read from cache. If true, read from database.
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiProgressionConfigurationProgressionConfigurationElementTreeIdGet(
      elementTreeId: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionConfigurationIRadianseResult> {
      return localVarFp
        .userApiProgressionConfigurationProgressionConfigurationElementTreeIdGet(
          elementTreeId,
          forceReread,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: progressionconfiguration_create
     * @summary Creates progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IProgressionConfigurationDto} [iProgressionConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiProgressionConfigurationProgressionConfigurationElementTreeIdPut(
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iProgressionConfigurationDto?: IProgressionConfigurationDto,
      options?: any
    ): AxiosPromise<IProgressionConfigurationIRadianseResult> {
      return localVarFp
        .userApiProgressionConfigurationProgressionConfigurationElementTreeIdPut(
          elementTreeId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iProgressionConfigurationDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: progressionconfiguration_read                Tanning guid fbd65957-9a8a-48ed-bd06-d09d2d99a490 will return a default configuration if not found.
     * @summary Get progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {boolean} [forceReread] If null or false, read from cache. If true, read from database.
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdGet(
      elementTreeId: string,
      forceReread?: boolean,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionConfigurationIRadianseResult> {
      return localVarFp
        .userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdGet(
          elementTreeId,
          forceReread,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: progressionconfiguration_create
     * @summary Creates progression configuration which is used in the progression calculations.
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {IProgressionConfigurationDto} [iProgressionConfigurationDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdPut(
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iProgressionConfigurationDto?: IProgressionConfigurationDto,
      options?: any
    ): AxiosPromise<IProgressionConfigurationIRadianseResult> {
      return localVarFp
        .userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdPut(
          elementTreeId,
          groupId,
          tenantId,
          acceptLanguage,
          iProgressionConfigurationDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ProgressionConfigurationApi - object-oriented interface
 * @export
 * @class ProgressionConfigurationApi
 * @extends {BaseAPI}
 */
export class ProgressionConfigurationApi extends BaseAPI {
  /**
   * Permission: progressionconfiguration_read                Tanning guid fbd65957-9a8a-48ed-bd06-d09d2d99a490 will return a default configuration if not found.
   * @summary Get progression configuration which is used in the progression calculations.
   * @param {string} elementTreeId
   * @param {boolean} [forceReread] If null or false, read from cache. If true, read from database.
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgressionConfigurationApi
   */
  public userApiProgressionConfigurationProgressionConfigurationElementTreeIdGet(
    elementTreeId: string,
    forceReread?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ProgressionConfigurationApiFp(this.configuration)
      .userApiProgressionConfigurationProgressionConfigurationElementTreeIdGet(
        elementTreeId,
        forceReread,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: progressionconfiguration_create
   * @summary Creates progression configuration which is used in the progression calculations.
   * @param {string} elementTreeId
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IProgressionConfigurationDto} [iProgressionConfigurationDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgressionConfigurationApi
   */
  public userApiProgressionConfigurationProgressionConfigurationElementTreeIdPut(
    elementTreeId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iProgressionConfigurationDto?: IProgressionConfigurationDto,
    options?: AxiosRequestConfig
  ) {
    return ProgressionConfigurationApiFp(this.configuration)
      .userApiProgressionConfigurationProgressionConfigurationElementTreeIdPut(
        elementTreeId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iProgressionConfigurationDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: progressionconfiguration_read                Tanning guid fbd65957-9a8a-48ed-bd06-d09d2d99a490 will return a default configuration if not found.
   * @summary Get progression configuration which is used in the progression calculations.
   * @param {string} elementTreeId
   * @param {boolean} [forceReread] If null or false, read from cache. If true, read from database.
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgressionConfigurationApi
   */
  public userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdGet(
    elementTreeId: string,
    forceReread?: boolean,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ProgressionConfigurationApiFp(this.configuration)
      .userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdGet(
        elementTreeId,
        forceReread,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: progressionconfiguration_create
   * @summary Creates progression configuration which is used in the progression calculations.
   * @param {string} elementTreeId
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [acceptLanguage]
   * @param {IProgressionConfigurationDto} [iProgressionConfigurationDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgressionConfigurationApi
   */
  public userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdPut(
    elementTreeId: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    iProgressionConfigurationDto?: IProgressionConfigurationDto,
    options?: AxiosRequestConfig
  ) {
    return ProgressionConfigurationApiFp(this.configuration)
      .userApiV1ProgressionConfigurationProgressionConfigurationElementTreeIdPut(
        elementTreeId,
        groupId,
        tenantId,
        acceptLanguage,
        iProgressionConfigurationDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ProgressionManagerApi - axios parameter creator
 * @export
 */
export const ProgressionManagerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: progressionmanager_read
     * @summary Get time allowed to use equipment
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IProgressionTimeReq} [iProgressionTimeReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiProgressionManagerTimePost: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iProgressionTimeReq?: IProgressionTimeReq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ProgressionManager/Time`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iProgressionTimeReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: progressionmanager_read
     * @summary Get time allowed to use equipment
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {IProgressionTimeReq} [iProgressionTimeReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ProgressionManagerTimePost: async (
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iProgressionTimeReq?: IProgressionTimeReq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/ProgressionManager/Time`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iProgressionTimeReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProgressionManagerApi - functional programming interface
 * @export
 */
export const ProgressionManagerApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    ProgressionManagerApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: progressionmanager_read
     * @summary Get time allowed to use equipment
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IProgressionTimeReq} [iProgressionTimeReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiProgressionManagerTimePost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iProgressionTimeReq?: IProgressionTimeReq,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionTimeRespIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiProgressionManagerTimePost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iProgressionTimeReq,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: progressionmanager_read
     * @summary Get time allowed to use equipment
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {IProgressionTimeReq} [iProgressionTimeReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ProgressionManagerTimePost(
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iProgressionTimeReq?: IProgressionTimeReq,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionTimeRespIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ProgressionManagerTimePost(
          groupId,
          tenantId,
          acceptLanguage,
          iProgressionTimeReq,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ProgressionManagerApi - factory interface
 * @export
 */
export const ProgressionManagerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProgressionManagerApiFp(configuration);
  return {
    /**
     * Permission: progressionmanager_read
     * @summary Get time allowed to use equipment
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IProgressionTimeReq} [iProgressionTimeReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiProgressionManagerTimePost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iProgressionTimeReq?: IProgressionTimeReq,
      options?: any
    ): AxiosPromise<IProgressionTimeRespIRadianseResult> {
      return localVarFp
        .userApiProgressionManagerTimePost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iProgressionTimeReq,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: progressionmanager_read
     * @summary Get time allowed to use equipment
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {IProgressionTimeReq} [iProgressionTimeReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ProgressionManagerTimePost(
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      iProgressionTimeReq?: IProgressionTimeReq,
      options?: any
    ): AxiosPromise<IProgressionTimeRespIRadianseResult> {
      return localVarFp
        .userApiV1ProgressionManagerTimePost(
          groupId,
          tenantId,
          acceptLanguage,
          iProgressionTimeReq,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ProgressionManagerApi - object-oriented interface
 * @export
 * @class ProgressionManagerApi
 * @extends {BaseAPI}
 */
export class ProgressionManagerApi extends BaseAPI {
  /**
   * Permission: progressionmanager_read
   * @summary Get time allowed to use equipment
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IProgressionTimeReq} [iProgressionTimeReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgressionManagerApi
   */
  public userApiProgressionManagerTimePost(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iProgressionTimeReq?: IProgressionTimeReq,
    options?: AxiosRequestConfig
  ) {
    return ProgressionManagerApiFp(this.configuration)
      .userApiProgressionManagerTimePost(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iProgressionTimeReq,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: progressionmanager_read
   * @summary Get time allowed to use equipment
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [acceptLanguage]
   * @param {IProgressionTimeReq} [iProgressionTimeReq]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgressionManagerApi
   */
  public userApiV1ProgressionManagerTimePost(
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    iProgressionTimeReq?: IProgressionTimeReq,
    options?: AxiosRequestConfig
  ) {
    return ProgressionManagerApiFp(this.configuration)
      .userApiV1ProgressionManagerTimePost(
        groupId,
        tenantId,
        acceptLanguage,
        iProgressionTimeReq,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ProgressionPersonApi - axios parameter creator
 * @export
 */
export const ProgressionPersonApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: progressionperson_read                Dictionary of progressions where key is elementTreeId.
     * @summary Gets the progression value a person has progressed to after a number of sessions completed.
     * @param {string} personId The  person the data is for
     * @param {string} elementTreeId The element tree the progression is about
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiProgressionPersonPersonIdElementTreeIdGet: async (
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiProgressionPersonPersonIdElementTreeIdGet",
        "personId",
        personId
      );
      // verify required parameter 'elementTreeId' is not null or undefined
      assertParamExists(
        "userApiProgressionPersonPersonIdElementTreeIdGet",
        "elementTreeId",
        elementTreeId
      );
      const localVarPath =
        `/UserApi/ProgressionPerson/{personId}/{elementTreeId}`
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
          .replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: progressionperson_read                Dictionary of progressions where key is elementTreeId.
     * @summary Gets the progression value a person has progressed to after a number of sessions completed.
     * @param {string} personId The  person the data is for
     * @param {string} elementTreeId The element tree the progression is about
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ProgressionPersonPersonIdElementTreeIdGet: async (
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiV1ProgressionPersonPersonIdElementTreeIdGet",
        "personId",
        personId
      );
      // verify required parameter 'elementTreeId' is not null or undefined
      assertParamExists(
        "userApiV1ProgressionPersonPersonIdElementTreeIdGet",
        "elementTreeId",
        elementTreeId
      );
      const localVarPath =
        `/UserApi/v1/ProgressionPerson/{personId}/{elementTreeId}`
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
          .replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProgressionPersonApi - functional programming interface
 * @export
 */
export const ProgressionPersonApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ProgressionPersonApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: progressionperson_read                Dictionary of progressions where key is elementTreeId.
     * @summary Gets the progression value a person has progressed to after a number of sessions completed.
     * @param {string} personId The  person the data is for
     * @param {string} elementTreeId The element tree the progression is about
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiProgressionPersonPersonIdElementTreeIdGet(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionPersonIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiProgressionPersonPersonIdElementTreeIdGet(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: progressionperson_read                Dictionary of progressions where key is elementTreeId.
     * @summary Gets the progression value a person has progressed to after a number of sessions completed.
     * @param {string} personId The  person the data is for
     * @param {string} elementTreeId The element tree the progression is about
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1ProgressionPersonPersonIdElementTreeIdGet(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionPersonIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1ProgressionPersonPersonIdElementTreeIdGet(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ProgressionPersonApi - factory interface
 * @export
 */
export const ProgressionPersonApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProgressionPersonApiFp(configuration);
  return {
    /**
     * Permission: progressionperson_read                Dictionary of progressions where key is elementTreeId.
     * @summary Gets the progression value a person has progressed to after a number of sessions completed.
     * @param {string} personId The  person the data is for
     * @param {string} elementTreeId The element tree the progression is about
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiProgressionPersonPersonIdElementTreeIdGet(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionPersonIRadianseResultSuccess> {
      return localVarFp
        .userApiProgressionPersonPersonIdElementTreeIdGet(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: progressionperson_read                Dictionary of progressions where key is elementTreeId.
     * @summary Gets the progression value a person has progressed to after a number of sessions completed.
     * @param {string} personId The  person the data is for
     * @param {string} elementTreeId The element tree the progression is about
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1ProgressionPersonPersonIdElementTreeIdGet(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionPersonIRadianseResultSuccess> {
      return localVarFp
        .userApiV1ProgressionPersonPersonIdElementTreeIdGet(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ProgressionPersonApi - object-oriented interface
 * @export
 * @class ProgressionPersonApi
 * @extends {BaseAPI}
 */
export class ProgressionPersonApi extends BaseAPI {
  /**
   * Permission: progressionperson_read                Dictionary of progressions where key is elementTreeId.
   * @summary Gets the progression value a person has progressed to after a number of sessions completed.
   * @param {string} personId The  person the data is for
   * @param {string} elementTreeId The element tree the progression is about
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgressionPersonApi
   */
  public userApiProgressionPersonPersonIdElementTreeIdGet(
    personId: string,
    elementTreeId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ProgressionPersonApiFp(this.configuration)
      .userApiProgressionPersonPersonIdElementTreeIdGet(
        personId,
        elementTreeId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: progressionperson_read                Dictionary of progressions where key is elementTreeId.
   * @summary Gets the progression value a person has progressed to after a number of sessions completed.
   * @param {string} personId The  person the data is for
   * @param {string} elementTreeId The element tree the progression is about
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgressionPersonApi
   */
  public userApiV1ProgressionPersonPersonIdElementTreeIdGet(
    personId: string,
    elementTreeId: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return ProgressionPersonApiFp(this.configuration)
      .userApiV1ProgressionPersonPersonIdElementTreeIdGet(
        personId,
        elementTreeId,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RequestContextApi - axios parameter creator
 * @export
 */
export const RequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet: async (
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1RequestContextGet: async (
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequestContextApi - functional programming interface
 * @export
 */
export const RequestContextApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequestContextGet(
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1RequestContextGet(
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1RequestContextGet(
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RequestContextApi - factory interface
 * @export
 */
export const RequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequestContextApiFp(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiRequestContextGet(apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1RequestContextGet(
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiV1RequestContextGet(acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequestContextApi - object-oriented interface
 * @export
 * @class RequestContextApi
 * @extends {BaseAPI}
 */
export class RequestContextApi extends BaseAPI {
  /**
   *
   * @summary
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiRequestContextGet(
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiRequestContextGet(apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiV1RequestContextGet(
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiV1RequestContextGet(acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SessionsApi - axios parameter creator
 * @export
 */
export const SessionsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: sessions_delete                If elementTreeId is tanning, Sessions holds the last 31 times a person has tanned, all the sessions will be deleted.
     * @summary Delete sessions and person\'s progression
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSessionsSessionsPersonIdElementTreeIdDelete: async (
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiSessionsSessionsPersonIdElementTreeIdDelete",
        "personId",
        personId
      );
      // verify required parameter 'elementTreeId' is not null or undefined
      assertParamExists(
        "userApiSessionsSessionsPersonIdElementTreeIdDelete",
        "elementTreeId",
        elementTreeId
      );
      const localVarPath =
        `/UserApi/Sessions/Sessions/{personId}/{elementTreeId}`
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
          .replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: sessions_read                If elementTreeId is tanning, this class holds the last 31 sessions a person has tanned.
     * @summary Gets a list of sessions
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSessionsSessionsPersonIdElementTreeIdGet: async (
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiSessionsSessionsPersonIdElementTreeIdGet",
        "personId",
        personId
      );
      // verify required parameter 'elementTreeId' is not null or undefined
      assertParamExists(
        "userApiSessionsSessionsPersonIdElementTreeIdGet",
        "elementTreeId",
        elementTreeId
      );
      const localVarPath =
        `/UserApi/Sessions/Sessions/{personId}/{elementTreeId}`
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
          .replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: sessions_delete                If elementTreeId is tanning, Sessions holds the last 31 times a person has tanned, all the sessions will be deleted.
     * @summary Delete sessions and person\'s progression
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1SessionsSessionsPersonIdElementTreeIdDelete: async (
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiV1SessionsSessionsPersonIdElementTreeIdDelete",
        "personId",
        personId
      );
      // verify required parameter 'elementTreeId' is not null or undefined
      assertParamExists(
        "userApiV1SessionsSessionsPersonIdElementTreeIdDelete",
        "elementTreeId",
        elementTreeId
      );
      const localVarPath =
        `/UserApi/v1/Sessions/Sessions/{personId}/{elementTreeId}`
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
          .replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: sessions_read                If elementTreeId is tanning, this class holds the last 31 sessions a person has tanned.
     * @summary Gets a list of sessions
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1SessionsSessionsPersonIdElementTreeIdGet: async (
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiV1SessionsSessionsPersonIdElementTreeIdGet",
        "personId",
        personId
      );
      // verify required parameter 'elementTreeId' is not null or undefined
      assertParamExists(
        "userApiV1SessionsSessionsPersonIdElementTreeIdGet",
        "elementTreeId",
        elementTreeId
      );
      const localVarPath =
        `/UserApi/v1/Sessions/Sessions/{personId}/{elementTreeId}`
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
          .replace(
            `{${"elementTreeId"}}`,
            encodeURIComponent(String(elementTreeId))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SessionsApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: sessions_delete                If elementTreeId is tanning, Sessions holds the last 31 times a person has tanned, all the sessions will be deleted.
     * @summary Delete sessions and person\'s progression
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiSessionsSessionsPersonIdElementTreeIdDelete(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionSessionsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiSessionsSessionsPersonIdElementTreeIdDelete(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: sessions_read                If elementTreeId is tanning, this class holds the last 31 sessions a person has tanned.
     * @summary Gets a list of sessions
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiSessionsSessionsPersonIdElementTreeIdGet(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionSessionsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiSessionsSessionsPersonIdElementTreeIdGet(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: sessions_delete                If elementTreeId is tanning, Sessions holds the last 31 times a person has tanned, all the sessions will be deleted.
     * @summary Delete sessions and person\'s progression
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1SessionsSessionsPersonIdElementTreeIdDelete(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionSessionsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1SessionsSessionsPersonIdElementTreeIdDelete(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: sessions_read                If elementTreeId is tanning, this class holds the last 31 sessions a person has tanned.
     * @summary Gets a list of sessions
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1SessionsSessionsPersonIdElementTreeIdGet(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IProgressionSessionsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1SessionsSessionsPersonIdElementTreeIdGet(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SessionsApiFp(configuration);
  return {
    /**
     * Permission: sessions_delete                If elementTreeId is tanning, Sessions holds the last 31 times a person has tanned, all the sessions will be deleted.
     * @summary Delete sessions and person\'s progression
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSessionsSessionsPersonIdElementTreeIdDelete(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionSessionsIRadianseResultSuccess> {
      return localVarFp
        .userApiSessionsSessionsPersonIdElementTreeIdDelete(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: sessions_read                If elementTreeId is tanning, this class holds the last 31 sessions a person has tanned.
     * @summary Gets a list of sessions
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSessionsSessionsPersonIdElementTreeIdGet(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionSessionsIRadianseResultSuccess> {
      return localVarFp
        .userApiSessionsSessionsPersonIdElementTreeIdGet(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: sessions_delete                If elementTreeId is tanning, Sessions holds the last 31 times a person has tanned, all the sessions will be deleted.
     * @summary Delete sessions and person\'s progression
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1SessionsSessionsPersonIdElementTreeIdDelete(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionSessionsIRadianseResultSuccess> {
      return localVarFp
        .userApiV1SessionsSessionsPersonIdElementTreeIdDelete(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: sessions_read                If elementTreeId is tanning, this class holds the last 31 sessions a person has tanned.
     * @summary Gets a list of sessions
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
     * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1SessionsSessionsPersonIdElementTreeIdGet(
      personId: string,
      elementTreeId: string,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IProgressionSessionsIRadianseResultSuccess> {
      return localVarFp
        .userApiV1SessionsSessionsPersonIdElementTreeIdGet(
          personId,
          elementTreeId,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
  /**
   * Permission: sessions_delete                If elementTreeId is tanning, Sessions holds the last 31 times a person has tanned, all the sessions will be deleted.
   * @summary Delete sessions and person\'s progression
   * @param {string} personId
   * @param {string} elementTreeId
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public userApiSessionsSessionsPersonIdElementTreeIdDelete(
    personId: string,
    elementTreeId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return SessionsApiFp(this.configuration)
      .userApiSessionsSessionsPersonIdElementTreeIdDelete(
        personId,
        elementTreeId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: sessions_read                If elementTreeId is tanning, this class holds the last 31 sessions a person has tanned.
   * @summary Gets a list of sessions
   * @param {string} personId
   * @param {string} elementTreeId
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public userApiSessionsSessionsPersonIdElementTreeIdGet(
    personId: string,
    elementTreeId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return SessionsApiFp(this.configuration)
      .userApiSessionsSessionsPersonIdElementTreeIdGet(
        personId,
        elementTreeId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: sessions_delete                If elementTreeId is tanning, Sessions holds the last 31 times a person has tanned, all the sessions will be deleted.
   * @summary Delete sessions and person\'s progression
   * @param {string} personId
   * @param {string} elementTreeId
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public userApiV1SessionsSessionsPersonIdElementTreeIdDelete(
    personId: string,
    elementTreeId: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return SessionsApiFp(this.configuration)
      .userApiV1SessionsSessionsPersonIdElementTreeIdDelete(
        personId,
        elementTreeId,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: sessions_read                If elementTreeId is tanning, this class holds the last 31 sessions a person has tanned.
   * @summary Gets a list of sessions
   * @param {string} personId
   * @param {string} elementTreeId
   * @param {string} [groupId] If using bearer token with group permissions, groupId must be included
   * @param {string} [tenantId] If using bearer token with tenant permissions, tenantId must be included
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public userApiV1SessionsSessionsPersonIdElementTreeIdGet(
    personId: string,
    elementTreeId: string,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return SessionsApiFp(this.configuration)
      .userApiV1SessionsSessionsPersonIdElementTreeIdGet(
        personId,
        elementTreeId,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
